import styled from '@emotion/styled'

export const Span = styled('span')`
  cursor: pointer;
  background-color: #FCFCFC;
  border: 1px solid #CCC;
  border-radius: 5px;
  color: #464646;
  font-size: 14px;
  padding: 0.3rem 0;
  text-align: center;
  width: 60px;

  &:hover {
    background-color: #CCC;
  }
`
